/// <amd-module name="SuiteCommerce.Blog.BlogHome.Configuration"/>
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define("SuiteCommerce.Blog.BlogHome.Configuration", ["require", "exports", "SuiteCommerce.Blog.Common.Configuration"], function (require, exports, Configuration_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var Interval;
    (function (Interval) {
        Interval["OFF"] = "OFF";
        Interval["5 sec"] = "5 sec";
        Interval["8 sec"] = "8 sec";
        Interval["13 sec"] = "13 sec";
    })(Interval || (Interval = {}));
    var IntervalMillisecondsMap = {
        OFF: 0,
        '5 sec': 5000,
        '8 sec': 8000,
        '13 sec': 13000,
    };
    var BlogHomeConfiguration = /** @class */ (function (_super) {
        __extends(BlogHomeConfiguration, _super);
        function BlogHomeConfiguration() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        Object.defineProperty(BlogHomeConfiguration, "blogHomeTitle", {
            get: function () {
                return this.get('blog.blogHomeTitle') || 'Blog';
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(BlogHomeConfiguration, "showFeaturedArticlesInPagination", {
            get: function () {
                return this.get('blog.showFeaturedArticlesInPagination');
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(BlogHomeConfiguration, "moreArticlesLabel", {
            get: function () {
                return this.get('blog.moreArticlesLabel');
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(BlogHomeConfiguration, "allArticlesTaxonomyName", {
            get: function () {
                return this.get('blog.allArticlesTaxonomyName');
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(BlogHomeConfiguration, "emptyStateLabel", {
            get: function () {
                return this.get('blog.emptyStateLabel');
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(BlogHomeConfiguration, "emptyStateMessage", {
            get: function () {
                return this.get('blog.emptyStateMessage');
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(BlogHomeConfiguration, "emptyStateButtonLabel", {
            get: function () {
                return this.get('blog.emptyStateButtonLabel');
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(BlogHomeConfiguration, "showLatestPostsSection", {
            get: function () {
                return this.get('blog.showLatestPostsSection');
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(BlogHomeConfiguration, "latestPostsLabel", {
            get: function () {
                return this.get('blog.latestPostsLabel');
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(BlogHomeConfiguration, "latestPostsCarouselInterval", {
            get: function () {
                var interval = this.get('blog.latestPostsCarouselInterval');
                return interval ? IntervalMillisecondsMap[interval] : 0;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(BlogHomeConfiguration, "titleForTagSearch", {
            get: function () {
                return this.translate('Articles tagged');
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(BlogHomeConfiguration, "titleForAuthorSearch", {
            get: function () {
                return this.translate('Articles written by');
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(BlogHomeConfiguration, "defaultSearchUrl", {
            get: function () {
                return this.get('defaultSearchUrl');
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(BlogHomeConfiguration, "showRssFeedLink", {
            get: function () {
                return this.get('blog.showRssFeedLink');
            },
            enumerable: true,
            configurable: true
        });
        return BlogHomeConfiguration;
    }(Configuration_1.Configuration));
    exports.BlogHomeConfiguration = BlogHomeConfiguration;
});
